export const orderTypes = {
    GET_ORDER_LIST: 'GET_ORDER_LIST',
};